import type { Transition, Variants } from 'framer-motion';

// Plan §16.3 — globale Motion-Tokens
export const easing = {
  smooth: [0.32, 0.72, 0, 1] as const,
  soft: [0.22, 1.0, 0.36, 1] as const,
  exit: [0.4, 0, 1, 1] as const,
};

export const duration = {
  instant: 0.12,
  quick: 0.2,
  medium: 0.32,
  slow: 0.5,
} as const;

export const pageTransition: Variants = {
  initial: { opacity: 0, y: 4 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
};

export const pageTransitionConfig: Transition = {
  duration: duration.medium,
  ease: easing.smooth,
};

export const modalBackdrop: Variants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

export const modalContent: Variants = {
  hidden: { opacity: 0, y: 8, scale: 0.98 },
  visible: { opacity: 1, y: 0, scale: 1 },
};

export const modalTransition: Transition = {
  duration: duration.medium,
  ease: easing.soft,
};

export const staggerContainer: Variants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.03,
      delayChildren: 0.05,
    },
  },
};

export const staggerItem: Variants = {
  hidden: { opacity: 0, y: 6 },
  visible: { opacity: 1, y: 0 },
};
